import { useEffect, useState } from "react";
import PublicLayout from "@/layouts/PublicLayout";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { Wine, Globe, Users, Calendar } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function AboutPage() {
  const { t } = useLang();
  const [stats, setStats] = useState({ members: 0, countries: 0, events_per_year: 0, poles: 0 });
  useEffect(() => {
    api.get("/public/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <Seo title={t("comp_aboutpage_90")} description="Discover the global ecosystem connecting wine innovation talents — startups, producers, technology providers, researchers, investors and partners shaping the future of wine." path="/about" />
      <section className="mx-auto max-w-5xl px-6 py-12">
        <div className="h-1 w-12 rounded-full bg-wine-500" />
        <h1 className="mt-3 text-4xl font-bold text-navy md:text-5xl">{t("comp_aboutpage_91")}</h1>
        <p className="mt-5 max-w-3xl text-lg text-neutral-700">
          La WineTech est la plateforme mondiale qui connecte les acteurs de l&apos;innovation dans la filière vin. Nous fédérons startups, producteurs, fournisseurs B2B, marketplaces et institutions pour faire émerger les solutions de demain.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {[
            { icon: Users, n: `${stats.members}+`, l: "Membres actifs" },
            { icon: Globe, n: String(stats.countries), l: "Pays représentés" },
            { icon: Calendar, n: String(stats.events_per_year), l: "Événements/an" },
            { icon: Wine, n: String(stats.poles), l: "Pôles d'innovation" },
          ].map((s) => (
            <div key={s.l} className="rounded-2xl border border-wine-100 bg-wine-50/30 p-5" data-testid={`about-stat-${s.l}`}>
              <s.icon className="h-6 w-6 text-wine-600" />
              <div className="mt-3 font-serif text-3xl font-semibold text-neutral-900">{s.n}</div>
              <div className="text-sm text-neutral-600">{s.l}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 space-y-10">
          <div>
            <h2 className="font-serif text-2xl text-neutral-900">{t("comp_aboutpage_92")}</h2>
            <p className="mt-3 leading-relaxed text-neutral-700">
              Connecter les talents, partager l&apos;innovation et façonner ensemble l&apos;avenir du vin. Nous croyons que l&apos;avenir de la filière passe par la collaboration entre tous ses acteurs.
            </p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-neutral-900">{t("comp_aboutpage_93")}</h2>
            <p className="mt-3 leading-relaxed text-neutral-700">
              Startups WineTech, domaines viticoles innovants, fournisseurs B2B, marketplaces, interprofessions, partenaires de l&apos;industrie, investisseurs et médias spécialisés.
            </p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-neutral-900">Gouvernance</h2>
            <p className="mt-3 leading-relaxed text-neutral-700">
              La WineTech est portée par une équipe et un board composés d&apos;acteurs reconnus du secteur. Nous publions une lettre annuelle d&apos;activité accessible à tous.
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-navy">Contact</h2>
            <p className="mt-3 text-neutral-700">📧 contact@lawinetech.com</p>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
